<template>
  <div class="box fclub-info" v-if="financialClubInfo">
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>

    <div class="page-header-wrapper logical-block">
      <div class="page-header translucent-wrapper" v-bind:style="headerStyle">

        <div class="centered">
          <span class="button-wrapper" @click="handleLoadFinancialClubPhoto">
            <a class="button is-info">+</a>Загрузить фото
          </span>
        </div>

        <b-field>
            <b-input placeholder="Заголовок" v-model="financialClubInfoObject.title"></b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Текст" type="textarea"
            v-model="financialClubInfoObject.description"></b-input>
        </b-field>
      </div>
    </div>

    <div class="logical-block">
      <div class="caption">
        <h2>Описание</h2>
      </div>

      <div class="fclub-info-description page-header-wrapper">
        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Текст" v-model="financialClubInfoObject.aboutTitle"
              class="p-option"></b-input>
          </b-field>

          <b-field>
            <Editor v-model="aboutDescription" :editorToolbar="customToolbar"
              v-bind:id="'aboutDescriptionEditor'" class="p-option color-black"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="logical-block">
      <div class="caption">
        <h2>Дополнительный текст</h2>
      </div>

      <div class="fclub-info-description page-header-wrapper">
        <div class="description-wrapper">
          <b-field>
            <Editor v-model="bottomText" :editorToolbar="customToolbar"
              v-bind:id="'bottomTextEditor'" class="p-option color-black"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveFinancialClub()" :disabled="disabled">
        {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import deepcopy from 'deepcopy'

  import { VueEditor as Editor } from 'vue2-editor'

  export default {
    name: 'FinancialClubInfo',

    data () {
      return {
        disabled: false,
        base64photo: '',
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{ 'align': [] }]
        ],
        aboutDescription: '',
        bottomText: ''
      }
    },

    computed: {
      ...mapState(['financialClubInfo']),
      financialClubInfoObject () {
        this.aboutDescription = this.financialClubInfo.aboutDescription
        this.bottomText = this.financialClubInfo.bottomText
        return deepcopy(this.financialClubInfo)
      },

      headerStyle () {
        if (this.financialClubInfo.photo || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.financialClubInfo.photo})` }
          } else {
            return {background: `url(${this.base64photo})`}
          }
        } else {
          return {background: ''}
        }
      }
    },

    methods: {
      ...mapActions(['getFinancialClubInfo', 'loadFinancialClubPhoto', 'saveFinancialClubInfo']),

      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64photo = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        console.log(file) // eslint-disable-line
        this.financialClubInfoObject.newPhoto = formData
      },

      handleLoadFinancialClubPhoto () {
        this.$refs.loadPhotoButton.click()
      },

      handleSaveFinancialClub () {
        this.disabled = true
        this.saveFinancialClubInfo(this.financialClubInfoObject)
          .then(() => {
            this.disabled = false
            this.$toast.open({ message: 'Сохранено' })
          }).catch(() => {
            this.disabled = false
            this.$toast.open({ message: 'Ошибка' })
          })
      }
    },

    created () {
      this.getFinancialClubInfo()
    },

    watch: {
      aboutDescription () {
        this.financialClubInfoObject.aboutDescription = this.aboutDescription
      },
      bottomText () {
        this.financialClubInfoObject.bottomText = this.bottomText
      }
    },

    components: { Editor }
  }
</script>

<style>
.fclub-info {
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
}

.fclub-info-description {
  margin: 0 auto;
  position: relative;
  background: #eeeeee;
  display: block !important;
}

.page-header-wrapper {
  background-size: cover !important;
  background-position: center !important;
}

.page-header {
  margin: 0 auto;
}

.p-option {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.description-wrapper {
  padding: 30px 20px;
}

.caption {
  text-align: center;
  margin: 20px 0;
}

.gray-wrapper {
  /* background: #eeeeee; */
  padding: 20px 20px;
}

.logical-block {
  margin-bottom: 40px;
}
.logical-block-content {
  background-color: #eeeeee;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?26eb5f95